//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MeasureBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"DiameterObjects",0,"SelectDisplayableObject",0],[1,"DistanceCollector1",0,"ScCollector",0],[1,"DistanceCollector2",0,"ScCollector",0],[0,"IsExact",1,0],[1,"LengthCollector",0,"ScCollector",0],[1,"LengthObjects",0,"SelectDisplayableObjectList",0],[0,"Mtype",1,0],[1,"Object1",0,"SelectDisplayableObject",0],[1,"Object2",0,"SelectDisplayableObject",0],[0,"ProjectionVector",1,"Direction",0],[1,"RadiusObjects",0,"SelectDisplayableObject",0],[1,"Set1",0,"SelectDisplayableObjectList",0],[1,"Set2",0,"SelectDisplayableObjectList",0]],[],[]];
SPLM.MeasureDistanceBuilder = class extends SPLM.MeasureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MeasureDistanceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MeasureDistanceBuilder.DistanceType = Object.freeze({
    "Distance" : "Distance", "SmartDistance" : "SmartDistance", "ProjectedDistance" : "ProjectedDistance", "SmartProjectedDistance" : "SmartProjectedDistance", "ScreenDistance" : "ScreenDistance", "Length" : "Length", "Radius" : "Radius", "Diameter" : "Diameter", "PointsOnCurves" : "PointsOnCurves", "RoutingPathLength" : "RoutingPathLength", "BetweenSets" : "BetweenSets"});

SPLM.MeasureDistanceBuilder.MeasureType = Object.freeze({
    "ToAPoint" : "ToAPoint", "Minimum" : "Minimum", "LocalMinimum" : "LocalMinimum", "Maximum" : "Maximum", "MinClearance" : "MinClearance", "MaxClearance" : "MaxClearance"});

export default SPLM;